import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const EmptyGridCell = styled.div``

export const DepositInvoiceMultiVatDescriptionRowWrapper = styled.div`
  margin-bottom: ${Spacing.S12};
  padding-bottom: ${Spacing.S12};
  border-bottom: 1px solid ${Color.Grey200};

  & > div {
    align-items: center;
  }
`

export const DepositInvoiceMultiVatEditButtonCell = styled.div`
  /* margin compensates padding and additional space on the Button to align it's text with grid */
  margin-right: calc(-${Spacing.S12} - ${Spacing.S10});
`

export const DepositInvoiceMultiVatSplitLabel = styled.div`
  padding-left: ${Spacing.S16};
`
